"use client";
import { LinearProgress } from "../components/legacy-ui/materialCompat";
import React from "react";

export default function Loading() {
  return (
    <main
      className="flex flex-col items-center h-screen"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999,
      }}
    >
      <LinearProgress
        color="error"
        sx={{ height: 4, width: "100%", backgroundColor: "#212121" }}
      />
    </main>
  );
}
